import home from "./Home";
import gettingStarted from "./GettingStarted";
import header from "./Header";
import gsoc from "./GSoC";
export const homeData = home;
export const gettingStartedData = gettingStarted;
export const headerData = header;
export const gsocData = gsoc;
